"use client";

import React, { FC, useState, useCallback } from "react";
import cx from "classnames";
import styles from "./vdp-section.module.scss";
import ArrowIcon from "@/ui/icons/arrow-icon";

interface IVDPSection {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  defaultOpenState?: boolean;
}

const VDPSection: FC<IVDPSection> = ({ children, title, subtitle, defaultOpenState }) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpenState ? defaultOpenState : true);

  const toggleContentOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <section className={styles.container}>
      <div
        className={cx(styles.header, {
          [styles.isOpen]: isOpen,
        })}
        onClick={toggleContentOpen}
      >
        <div className={styles.headerLeft}>
          <span className={styles.headerTitle}>{title}</span>
          {subtitle && <span className={styles.headerSubtitle}>{subtitle}</span>}
        </div>
        <ArrowIcon />
      </div>
      {isOpen && <div className={styles.content}>{children}</div>}
    </section>
  );
};

export default VDPSection;
